import { pathgen } from 'object-path-generator';
export const AddServicesTestIds = pathgen('AddServicesFilterPickerTestIds');
